var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-fluid password-container",
      class: { hide_banner: !_vm.isTokenValid },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center" },
          [
            _vm.isTokenValid
              ? _c("div", { staticClass: "login-whitebox" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12 pass-info" },
                    [
                      _c("p", { staticClass: "pass-desc" }, [
                        _vm._v("Provide Password Details:"),
                      ]),
                      _c(
                        "el-popover",
                        {
                          staticClass: "info-icon-class",
                          attrs: {
                            "popper-append-to-body": "false",
                            placement: "bottom-end",
                            trigger: "click",
                            "popper-class":
                              "popup-background tootip-custom-small-width-class",
                          },
                          on: {
                            show: function ($event) {
                              _vm.passwordInfoActive = true
                            },
                            hide: function ($event) {
                              _vm.passwordInfoActive = false
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "content" }, [
                            _c("ul", { staticClass: "word-break" }, [
                              _c("li", [
                                _vm._v(
                                  " Your password must be at least 10 characters and meet any 3 of these 4 criteria: 1 capital letter (A-Z), 1 lowercase letter ( a-z), 1 number (1-9), and one special character (!@#$.,+=( )_%^&*) "
                                ),
                              ]),
                            ]),
                          ]),
                          !_vm.passwordInfoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon.svg",
                                  alt: "info-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _vm.passwordInfoActive
                            ? _c("img", {
                                staticClass: "info-img",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon_active.svg",
                                  alt: "infoactive-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "login-container" }, [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.resetPassword.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-sm-12 login-input form-group" },
                          [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("New Password"),
                            ]),
                            _c("span", { staticClass: "required_astric" }, [
                              _vm._v("*"),
                            ]),
                            _c("div", { staticClass: "password-flex" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.data.password.$model,
                                    expression: "$v.data.password.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                ref: "inputNewTag",
                                staticClass:
                                  "login-input-box landing-input-field",
                                class: {
                                  field_error: _vm.$v.data.password.$error,
                                },
                                attrs: {
                                  type: "password",
                                  name: "password",
                                  placeholder: "New password",
                                },
                                domProps: {
                                  value: _vm.$v.data.password.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.data.password,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.showNewPassword
                                ? _c("img", {
                                    staticClass: "eye-icon",
                                    attrs: {
                                      src: "/static/images/icons/eye.svg",
                                      alt: "eye-icon",
                                    },
                                    on: { click: _vm.toggleNewPassword },
                                  })
                                : _vm._e(),
                              !_vm.showNewPassword
                                ? _c("img", {
                                    staticClass: "eye-slash-icon",
                                    attrs: {
                                      src: "/static/images/icons/eye_slash.svg",
                                      alt: "eye-icon",
                                    },
                                    on: { click: _vm.toggleNewPassword },
                                  })
                                : _vm._e(),
                            ]),
                            _vm.$v.data.password.$error
                              ? _c("div", { staticClass: "error_text" }, [
                                  !_vm.$v.data.password.required
                                    ? _c("div", [
                                        _vm._v("Password is required."),
                                      ])
                                    : _vm._e(),
                                  _vm.$v.data.password.required &&
                                  !_vm.$v.data.password.passwordValidation
                                    ? _c("div", [
                                        _vm._v(
                                          " Your password must be at least 10 characters and meet any 3 of these 4 criteria: 1 capital letter (A-Z), 1 lowercase letter ( a-z), 1 number (1-9), and one special character (!@#$.,+=( )_%^&*) "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-12 login-input form-group mb-32",
                          },
                          [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("Confirm Password"),
                            ]),
                            _c("span", { staticClass: "required_astric" }, [
                              _vm._v("*"),
                            ]),
                            _c("div", { staticClass: "password-flex" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.data.confirm_password.$model,
                                    expression:
                                      "$v.data.confirm_password.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                ref: "inputConfirmTag",
                                staticClass:
                                  "login-input-box landing-input-field",
                                class: {
                                  field_error:
                                    _vm.$v.data.confirm_password.$error,
                                },
                                attrs: {
                                  type: "password",
                                  name: "confirm_password",
                                  placeholder: "Confirm Password",
                                },
                                domProps: {
                                  value: _vm.$v.data.confirm_password.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.data.confirm_password,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.showConfirmPassword
                                ? _c("img", {
                                    staticClass: "eye-icon",
                                    attrs: {
                                      src: "/static/images/icons/eye.svg",
                                      alt: "eye-icon",
                                    },
                                    on: { click: _vm.toggleConfirmPassword },
                                  })
                                : _vm._e(),
                              !_vm.showConfirmPassword
                                ? _c("img", {
                                    staticClass: "eye-slash-icon",
                                    attrs: {
                                      src: "/static/images/icons/eye_slash.svg",
                                      alt: "eye-icon",
                                    },
                                    on: { click: _vm.toggleConfirmPassword },
                                  })
                                : _vm._e(),
                            ]),
                            _vm.$v.data.confirm_password.$error
                              ? _c("div", { staticClass: "error_text" }, [
                                  !_vm.$v.data.confirm_password.required
                                    ? _c("div", [
                                        _vm._v("Please confirm your password"),
                                      ])
                                    : _vm._e(),
                                  _vm.$v.data.confirm_password.required &&
                                  !_vm.$v.data.confirm_password.sameAsPassword
                                    ? _c("div", [
                                        _vm._v(
                                          " The password doesn't match the password above "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c("div", { staticClass: "d-flex terms-block" }, [
                            _c("span", { staticClass: "checkbox mr-12" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value:
                                        _vm.$v.data.terms_conditions.$model,
                                      expression:
                                        "$v.data.terms_conditions.$model",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: { type: "checkbox", value: "true" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.$v.data.terms_conditions.$model
                                    )
                                      ? _vm._i(
                                          _vm.$v.data.terms_conditions.$model,
                                          "true"
                                        ) > -1
                                      : _vm.$v.data.terms_conditions.$model,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.$v.data.terms_conditions.$model,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "true",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$v.data.terms_conditions,
                                              "$model",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$v.data.terms_conditions,
                                              "$model",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.$v.data.terms_conditions,
                                          "$model",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "cr" }),
                              ]),
                            ]),
                            _vm._m(0),
                          ]),
                          _vm.$v.data.terms_conditions.$error
                            ? _c("div", { staticClass: "error_text pl-40" }, [
                                !_vm.$v.data.terms_conditions.checked
                                  ? _c("div", [
                                      _vm._v(
                                        " You must accept the RAMS SaaS Agreement to proceed "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "col-sm-12 emergo-button" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn emergo-green-button",
                              attrs: {
                                type: "submit",
                                disabled: _vm.disableButton,
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.ButtonText) + " ")]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.linkExpired
              ? _c(
                  "div",
                  [
                    _c("invalid-token-message", {
                      attrs: { page: "resetpassword" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "terms-conditions" }, [
      _vm._v(" I acknowledge that I have read and agreed to the "),
      _c("a", { attrs: { href: "/terms-of-service", target: "_blank" } }, [
        _vm._v("RAMS Software-as-a-Service Agreement"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }